<template>
    <div v-if="isShow" class="progress">
        <el-link :underline="false">文件上传进度</el-link>
        <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage" status="success"></el-progress>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        isShow: Boolean,
        percentage: Number
    },
    data() {
        return {};
    }
};
</script>
<style scoped lang="scss">
.progress {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .el-link {
        margin: 0 15px;
    }
    .el-progress {
        width: 240px;
    }
}
</style>
